import { Typography, TypographyProps } from '@mui/material';

export const Paragraph = ({ children, ...props }: TypographyProps) => {
  return (
    <Typography variant="body2" {...props}>
      {children}
    </Typography>
  );
};
